import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/button";
import { heroImg1 } from "../../assets";
import { heroImg2 } from "../../assets";
import colors from "../../utils/colors";

const HeroSection = () => {
  const navigate = useNavigate();
  const images = [heroImg1, heroImg2];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000); // change every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mx-4 sm:mx-8 md:mx-12 lg:mx-[4.22rem] flex flex-col items-center gap-8 sm:gap-10 md:gap-[2.5rem] py-8 sm:py-12">
      <div className="flex flex-col gap-4 sm:gap-5 md:gap-[1.25rem] text-center">
        <div
          style={{ color: colors.primary }}
          className="font-lexend text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] font-semibold leading-tight sm:leading-snug md:leading-[4.4rem] tracking-[0.035rem]"
        >
          {`Manage your patient's health records seamlessly`}
        </div>
        <div className="w-full flex justify-center">
          <div
            style={{ color: colors.lightGrey }}
            className="font-lato text-base sm:text-lg md:text-[1.25rem] font-normal text-center max-w-xl lg:w-[56.8rem]"
          >
            {`We're committed to making your practice more efficient and patient focused. Use our innovative tools to speed up your day to day activities`}
          </div>
        </div>
      </div>

      <Button
        text="Create Account"
        theme="primary"
        className="w-full max-w-xs sm:w-auto px-6 sm:px-[2rem] py-3 sm:py-[1rem] rounded-md sm:rounded-[0.5rem] text-sm sm:text-base"
        onClick={() => navigate("/signup")}
      />

      {/* Image container with fade effect and content-based size */}
      <div className="relative w-fit">
        {images.map((img, idx) => (
          <img
            key={idx}
            src={img}
            alt={`Hero ${idx}`}
            className={`absolute top-0 left-0 w-full h-auto rounded-lg transition-opacity duration-1000 ease-in-out ${
              idx === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
            style={{ transitionProperty: "opacity" }}
          />
        ))}
        {/* Keeps layout by showing current image without absolute positioning */}
        <img
          src={images[currentIndex]}
          alt="Visible Hero"
          className="w-full h-auto rounded-lg invisible"
        />
      </div>
    </div>
  );
};

export default HeroSection;
